import AxiosPermisos from './axiosPermisos'
import {
  map_query
} from "@/core/functions/map-path-query"

/* all URI to API */
const uri = {
  core_employee: '/coreEmployees',
  identification_accessUri: '/identification/access',
  changeLetterUri: '/licTemplate',
  getTemplateUri: '/licTemplate/1',
  getBPUri: '/coreEmployeesFilter', // Trae todos los Business Partners
  saveRequestUri: '/licLicense'
  , limit_request_validation : '/lic-licenses/validate-tickets-available'
  , getLicensesUri: '/licLicense',
  getRequestUri: '/licLicense',
  saveTktApprovalUri: '/licTickets/status',
  saveTktFileUri: '/licTickets/charge',
  saveCommentsUri: '/licComments',
  getWorkersUri: '/workersLicense',
  saveApprovalUri: '/licLicense/employeesStatus', //'/licEmployeeDays',
  getRequestsFreeUri: '/licLicense/freeUser',
  getRequestFreeUri: '/licLicense/letter',
  getOnboardingUri: '/onBoardings',
  getDashboardUri: '/licStats',
  //updateStateRequestUri: '/licLicense/licenseStatus',
  getFilterAdvUri: '/licLicense',
  getApproverSggsted: '/suggestedApprovers',
  getLaborUnionsUri: '/laborUnions',
  getFaqUri: '/faq',
  getAvailabilityUri: '/licLicense/availability',
  getProfileUri: '/coreEmployees',
  saveSignatureUri: '/coreEmployees/signature',
  savePwdChangeUri: '/coreEmployees/password',
  emailRecoveryUri: '/coreEmployees/forgot',
  savePwdNewUri: '/coreEmployees/new_pass',
  getSocietiesInfoURI: '/societies', // Valida si la sociedad puede realizar permisos por horas.
  getAbsenteeismUri: '/absenteeism',
  getSettingsUri: '/settings',
  sendEmailDocsUri: '/licLicense/mail',
  getSitesUri: '/sites',
  getSocietiesUri: '/allSocieties',
  getAllSitesBPUri: '/allSitesBP',
  getDashboardBarUri: '/licLicense/stats',
  getModalsUri: '/modals',
  getNotificationsUri: '/notifications',
  updateReadNtftnUri: '/licLicense/view',
  //requestReviewUri: '/licLicense/requestReview',
  saveObsAbseUri: '/absenteeism',
  getCitiesUri: '/cities',
  getStatesUri: '/departments',
  getCountriesUri: '/countries',
  checkHolidayUri: '/holidays/verify',
  getCategoriesUri: '/prCategories',
  saveRightPetitionUri: '/petitionRights',
  getResponsiblesUri: '/coreEmployeesFilter?param=core_role_id&key=8',
  setRequestStatusUri: '/licLicense/status',
  saveInfoRPUri: '/petitionRights/information',
  sendMsjAdminUri: '/dataInconsistency',
  addUserForumUri: '/prForums/participants',
  getfilesUri: '/prFiles',
  sendResponseUri: '/prAnswers',
  getInfoForumUri: '/prForums',
  sendCommentUri: '/prForums/comments',
  sendFilesForumUri: '/prForums/files',
  getEvidencesRPUri: '/prEvidences',
  getEvidencesTemporalRPUri: '/temporalPrEvidences',
  sendRequestBPUri: '/prEvidences/request',
  //getInformerInfoUri: '/coreEmployees/consult'
  getInformerInfoUri: '/prForums/list',
  //deleteFileForumUri: '/prFiles',
  deleteFileForumUri: '/prForums/removeFile',
  deleteFileEvidenceUri: '/prEvidences/delete',
  putStatusForumUri: '/prForums/status',
  getDashboardRPUri: '/prStats',
  sendPushUri: '/prForums/participants/push',
  deleteFileResUri: '/prFiles/delete',
  recategorizeUri: '/petitionRights/recategorize',
  getAnswersUri: '/prAnswers',
  deleteTemporalEvidenceUri: '/prAnswers/removeEvidence',
  setStatusUserFrmUri: '/prForums/participants',
  validateUserFrmUri: '/prForums/validateParticipant',
  coreEmployeesFilterUri: '/coreEmployeesFilter',

  coordinatorsByBPUri: '/coreEmployees/bossesByBP',
  proceReportUri: '/proceReports',
  proceEvidencesUri: '/proceEvidences',
  proceEmployeesUri: '/proceEmployees',
  proceCitationsUri: '/proceCitations',
  proceLaborRelationsUri: '/proceLaborRelations',
  proceCommentsUri: '/proceComments',
  proceDiligencesUri: '/proceDiligences',
  procePenaltiesUri: '/procePenalties',
  procePenaltyEvidenceUri: '/procePenaltyEvidence',
  proceQuestionCategoriesUri: '/proceQuestionCategories',
  proceQuestionsUri: '/proceQuestions',
  proceRequestEvidenceUri: '/proceRequestEvidences',
  proceDashboardControllerUri: '/proceDashboardController',
  proceHolidaysUri: '/holidaysVerify',

  getBusinessDateUri: '/customizes/business-days/:date/:ticket_type',

  // Virtual Partner V 2.0
  getTipshiftReport: '/propinas/collaborator/index',
  getTipshiftReportBodega: '/propinas/supervisor/index',
  getAutocompleteNovedadesUrl: '/autocomplete/',
  SetNovedadesUrl: '/propinas/closeCollaborator/create',
  SetUpdateNovedadesUrl: '/propinas/closeCollaborator/update',
  getReportPropinas: '/propinas/report/search',
  getReportPdvEscenarios: '/propinas/points-sale/index',
  getReportIndexList: '/propinas/points-sale/lists',
  saveReportPdvEscenarios: '/propinas/points-sale/update-scene',
  getReportColaboradoresNovedades: '/propinas/report/show',
  getReportHistory: '/propinas/report/changeHistory',
  getBodegasSupervisorUrl: '/propinas/supervisor/points',

  //////////// PERFIL DE NOMINA ///// ACTUALIZACIÓN DE LA INFORMACIÓN

  getRolesVP2: '/propinas/charges/list-roles',

  getSelectionsData: '/general/lists/index',

  getBanks: '/general/lists',
  saveBank: '/general/lists/store',

  getLineDeal: '/propinas/lineDeal',
  saveLineDeal: '/propinas/lineDeal/create',
  actLineDeal: '/propinas/lineDeal/update',
  delLineDeal: '/propinas/lineDeal/delete',

  getSupportBags: '/propinas/support-bags',
  saveSupportBag: '/propinas/support-bags/store',

  getScenario: '/propinas/scenarios',
  getScenarioByLd: '/propinas/scenarios/by-line-deal',
  saveScenario: '/propinas/scenarios/store',

  getServices: '/propinas/charges/list',
  getCharges: '/propinas/charges/index',
  getChargesByPointSales: '/propinas/charges/by-point-sale-scene',
  saveCharge: '/propinas/charges/store',
  getCharge: '/propinas/charges',

  getPointsSales: '/propinas/points-sale',
  getPointsSalesByZone: '/propinas/points-sale/by-zone',
  savePointSale: '/propinas/points-sale/store',
  actPointSale: '/propinas/points-sale/update',
  delPointSale: '/propinas/points-sale',

  getGroupOfCharges: '/propinas/sections/index',
  saveGroupOfCharges: '/propinas/sections/create',
  actGroupOfCharges: '/propinas/sections/update',
  delGroupOfCharges: '/propinas/sections/delete',

  getZones: '/propinas/zones/index',
  saveZone: '/propinas/zones/store',
  getZone: '/propinas/zones',
  getZoneByLB: '/propinas/zones/by-line-deal',

  getEmployees: '/propinas/employees/index',
  saveEmployee: '/propinas/employees/store',
  getEmployee: '/propinas/employees',
  getLists: '/propinas/employees/lists',
  getCustomList: '/propinas/employees/custom-lists',
  generateExcelWorkers: '/propinas/bulk-load/download-template',

  saveFileEmployee: '/propinas/bulk-load/upload',

  //////////// PERFIL DE NOMINA ///// PUNTAJES

  getInfoLineDeal: '/propinas/percentage-adjustment/support-bags/by-line-deal',
  getAllSupportBags: '/propinas/percentage-adjustment/support-bags',
  getInfoBySupportBag: '/propinas/percentage-adjustment/charges',
  getInfoByScenario: '/propinas/percentage-adjustment/scenarios',
  getChargesBySupportBag: '/propinas/percentage-adjustment/charges/by-support-bag',
  savePointsChargeByLineDeal: '/propinas/percentage-adjustment/update/charge/by-line-deal',
  savePointsSupportBagByLineDeal: '/propinas/percentage-adjustment/update/support-bag/by-line-deal',
  savePointsChargeByScene: '/propinas/percentage-adjustment/update/charge/by-scene',
  savePointsSalesPointBySupportBag: '/propinas/percentage-adjustment/update/point-sale/by-support-bag',
  savePointsChargesBySupportBag: '/propinas/percentage-adjustment/update/charge/by-support-bag',

  getModificationHistory: '/propinas/percentage-adjustment/modification-history',
  getUpdateHistory: '/propinas/percentage-adjustment/modification-history',

  // COMPONENTE DE PROPINAS
  getTipsGeneral: '/propinas/report/reportGeneralTips',
  getTipsLineDeal: '/propinas/report/tipsForLineDeal',
  getTipsZone: '/propinas/report/tipsForZone',
  getTipsPointSale: '/propinas/report/tipsPointSale',
  getTipsDaily: '/propinas/report/tipsDaily',

  // DATATABLE 
  listPointSales: '/propinas/report/listPointSales',
  listPointSalesDaily: '/propinas/report/listTipsDaily',
  listZoneSales: '/propinas/report/listZoneSales',
  listZones: '/propinas/report/getZones',
  getPointSales: '/propinas/report/getPointSales',
  getlineDeals: '/propinas/report/lineDeal',

  listNovelties: '/propinas/novelty/index',
  listDetailNovelties: '/propinas/novelty/detailNovelty',
  confirmNoveltie: '/propinas/novelty/status',


  iAmIsLocked: '/propinas/manager/iam-blocked',
  enableToTurnReport: '/propinas/manager/blocks/',
  turnReportLock: '/propinas/manager/my-locks',

  //////////// PERFIL JEFE DE ZONA ///// ENTRENAMIENTO

  getTrainingInfo: '/propinas/training-request',
  saveFileSiesa: '/propinas/importSIESA/import',

  //++++++++++++++++++++++++++++++++++++++++++++++++++//
  //////+++++++++++ HEALTH TRACKER ++++++++++++++///// 
  //++++++++++++++++++++++++++++++++++++++++++++++++++//

  ////////////////////// AUSENTISMOS ////////////////////////

  getEmployeesBySearch: '/health-tracker/worker-profile/searcher-employees',
  getEmployeeInfo: '/health-tracker/worker-profile/employee',
  getTypesAbsenteeism: '/health-tracker/absenteeism/types-absenteeism',
  getGroupsDiagnostics: '/health-tracker/absenteeism/groups-diagnostics',
  getDiagnostics: '/health-tracker/absenteeism/diagnostics',
  getRiskClassification: '/health-tracker/absenteeism/risk-classification',
  getListsAbsenteeism: '/health-tracker/absenteeism/lists',
  saveAbsenteeism: '/health-tracker/absenteeism/store',
  getAbsenteeism: '/health-tracker/absenteeism',
  getHistoryOfAbsenteeism: '/health-tracker/absenteeism-history',
  getDetailAbsenteeism: '/health-tracker/absenteeism-summary-employee',
  saveFileEmployeeHT: '/health-tracker/import/employees',
  save_file_cie10_ht: '/health-tracker/absenteeism/cie10/import',
  saveFileAbs: '/health-tracker/absenteeism/upload/report',
  filterEmployeeDetail: '/health-tracker/absenteeism/filters',
  getAllSocietys: '/health-tracker/reports/all-societies',
  getAllAreas: '/health-tracker/reports/all-areas',
  filterStadistics: '/health-tracker/reports/data-report',
  getTablesInform: '/health-tracker/reports/data-report-by-table',
  checkEmployeesWithPhoto: '/health-tracker/images-employees/list',
  checkEmployeesWithPhone: '/health-tracker/phones-employees/list',
  checkResponsiblePhones: '/health-tracker/phones-employees/responsible',
  getEmployeePhone:'/health-tracker/phones-employees/phone-employee',
  saveEmployeePhone:'/health-tracker/phones-employees/update-phone-employee',
  checkResponsiblePhotos: '/health-tracker/images-employees/responsible',
  assignResponsiblePhotos: '/health-tracker/images-employees/assigment-responsibility-upload-images',
  assignResponsiblePhones:'/health-tracker/phones-employees/assigment-responsibility-upload-phones',
  uploadImagesEmployees:'/health-tracker/images-employees/upload-images',
  uploadPhonesEmployees:'/health-tracker/phones-employees/upload-file',
  progressBarPhones:'/health-tracker/phones-employees/data-progress-bar',
  progressBarPhotos:'/health-tracker/images-employees/data-progress-bar',

  ////////////////////// GES ////////////////////////

  getSVElist:'/health-tracker/ges/lists',
  saveGES:'/health-tracker/ges/store',
  getGES:'/health-tracker/ges',
  getGESTable:'/health-tracker/ges',
  getEmployeeGES:'/health-tracker/ges/employees-by-ges',
  //saveEmployeeGES:'/health-tracker/ges/ges-employee',
  saveEmployeeGES:'/health-tracker/ges',
  //deleteEmployeeGES:'/health-tracker/ges/employee-ges',
  deleteEmployeeGES:'/health-tracker/ges',
  getHistoryGES:'/health-tracker/ges/history',
  ////////////////////// GESDASHBOARD ////////////////////////
  getSveDash:'/health-tracker/ges/dashboard/sve',
  getSveGesDash:'/health-tracker/ges/dashboard/sve',
  getSveGesClDash:'/health-tracker/ges/dashboard/classification',
  getSvePercDash:'/health-tracker/ges/percentage-by-sve',
  getSveDash_Char:'/health-tracker/ges/dashboard/characterization',
  getSveDashPandA:'/health-tracker/ges/dashboard/case-management-by-process-and-areas',
  getSveGesOha:'/locations',

  
  ////////////////////// RIESGO POTENCIAL ////////////////////////

  getGesPotencialRisk:'/health-tracker/risk-potential/get-ges',
  saveGesPotencialRisk:'/health-tracker/risk-potential/ges',

  ////////////////////// HISTORICO LABORAL ////////////////////////

  uploadFileHistoryWorker:'/health-tracker/worker-history/upload',

  ////////////////////// DIAGNOSTICOS ////////////////////////

  getListsForDiagnostics:'/health-tracker/disease-detail/lists',
  getAllDiagnostics:'/health-tracker/disease-detail/get-details',
  saveNewDiagnostic:'/health-tracker/disease-detail/save',
  getDiagnostic:'/health-tracker/disease-detail',
  getCompleteDiagnostic:'/health-tracker/health-factors/resume',
  editDiagnostic:'/health-tracker/disease-detail/update',
  deleteDiagnostic:'/health-tracker/disease-detail',

  //Calificación del Diagnóstico

  getListCalifications:'/health-tracker/qualification-disease-detail/list',
  getCalification:'/health-tracker/qualification-disease-detail/show',
  saveNewCalification:'/health-tracker/qualification-disease-detail/save',
  editCalification:'/health-tracker/qualification-disease-detail',

  //APT

  getListAPTs:'/health-tracker/apt-disease-detail/list',
  getAPT:'/health-tracker/apt-disease-detail/show',
  saveNewAPT:'/health-tracker/apt-disease-detail/save',
  editAPT:'/health-tracker/apt-disease-detail',

  //PCL
  getListDiseases:'/health-tracker/pcl-disease-detail/list-diseases',
  getListPCLs:'/health-tracker/pcl-disease-detail/list',
  getPCL:'/health-tracker/pcl-disease-detail/show',
  saveNewPCL:'/health-tracker/pcl-disease-detail/save',
  editPCL:'/health-tracker/pcl-disease-detail',

  //++++++++++++++++++++++++++++++++++++++++++++++++++//
  //////+++++++++++ PROPINA EMPLEADOS ++++++++++++++///// 
  //++++++++++++++++++++++++++++++++++++++++++++++++++//



  getTipsEmployee: '/propinas/reportCollaborator/getTips',
}



//all services of Permisos
export default {
  /* 
   *
   * CORE AUTENTHICATION 
   *
   */
  core_employee: async (data) => {
    return await AxiosPermisos.get(uri.core_employee + "/" + data.id, true);
  },
  updatedTerminsAndConditons: async (id, data) => {
    return await AxiosPermisos.put(uri.core_employee + "/" + id, true, data);
  },
  core_employee_bp: async (data) => {
    return await AxiosPermisos.get(uri.core_employee + "/" + data.site.business_partner, true);
  },

  identification_access: async (data) => {
    //validate if the user exists
    return await AxiosPermisos.post(uri.identification_accessUri, false, data);
  },

  getOnboarding: async () => {
    return await AxiosPermisos.get(uri.getOnboardingUri, true);
  },

  getProfile: async (id) => {
    return await AxiosPermisos.get(uri.getProfileUri + "/" + id, true);
  },

  saveSignature: async (signature) => {
    return await AxiosPermisos.postSendFile(uri.saveSignatureUri, true, signature);
  },

  savePwdChange: async (data) => {
    return await AxiosPermisos.post(uri.savePwdChangeUri, true, data);
  },

  emailRecovery: async (email) => {
    return await AxiosPermisos.post(uri.emailRecoveryUri, true, email);
  },

  savePwdNew: async (data) => {
    return await AxiosPermisos.post(uri.savePwdNewUri, true, data);
  },

  sendMsjAdmin: async (data) => {
    return await AxiosPermisos.post(uri.sendMsjAdminUri, true, data);
  },

  /* 
   *
   * EDIT LETTER 
   *
   */
  changeLetter: async (data) => {
    return await AxiosPermisos.post(uri.changeLetterUri, true, data);
  },
  //Trae la informacion del template
  GetTemplate: async () => {
    return await AxiosPermisos.get(uri.getTemplateUri, true);
  },

  /* 
   *
   * REQUEST
   *
   */
  saveRequest: async (data) => {
    return await AxiosPermisos.post(uri.saveRequestUri, true, data);
  },

  limitRequestValidation: async (data) => {
    return await AxiosPermisos.get(uri.limit_request_validation.concat(map_query(data)), true)
  },

  GetBusinessDate: async ({ date, ticket_type }) => {
    const params = ticket_type == '' ? `${date}` : `${date}/${ticket_type}`
    let url = uri.getBusinessDateUri.replace(/:date\/:ticket_type/, params)
    return await AxiosPermisos.get(url, true)
  },

  GetBP: async (data = {}) => {
    /*let DP = ''
    if (data) {
      DP = '&origin=dp'
    }*/
    let url = uri.getBPUri
    if (Object.keys(data).length > 0) { url = url.concat(map_query(data)) }
    // let filter = '?param=core_role_id&key=2'
    return await AxiosPermisos.get(url, true);
  },

  GetRequest: async (data) => {
    return await AxiosPermisos.get(uri.getRequestUri + "/" + data, true);
  },

  saveComments: async (data) => {
    return await AxiosPermisos.post(uri.saveCommentsUri, true, data);
  },

  getWorkers: async (data) => {
    return await AxiosPermisos.get(uri.getWorkersUri + "/" + data[0] + "/" + data[1] + "/" + data[2], true);
  },

  getRequestFree: async (id, idUser) => {
    return await AxiosPermisos.get(uri.getRequestFreeUri + "/" + id + '/' + idUser, {});
    //return await AxiosPermisos.get(uri.getRequestUri+"/"+id, {});
  },

  getRequestsFree: async (cc) => {
    return await AxiosPermisos.post(uri.getRequestsFreeUri, {}, cc);
  },

  getDashboard: async (data) => {
    let anno = data[0];
    let id_labor_union = data[1];

    return await AxiosPermisos.get(uri.getDashboardUri + "/" + anno + "/" + id_labor_union, true);
  },

  /*updateStateRequest: async (id,status) => {
    return await AxiosPermisos.post(uri.updateStateRequestUri+'/'+id, true, status);
  },*/

  setRequestStatus: async (id, status) => {
    return await AxiosPermisos.post(uri.setRequestStatusUri + '/' + id, true, status);
  },

  updateRequestTkts: async (id, data) => {
    return await AxiosPermisos.patch(uri.saveRequestUri + '/' + id, true, data);
  },

  approverSggsted: async (sharp_id) => {
    return await AxiosPermisos.get(uri.getApproverSggsted + "/" + sharp_id, true);
  },

  getLaborUnions: async () => {
    return await AxiosPermisos.get(uri.getLaborUnionsUri, true);
  },

  getAvailability: async (societyID) => {
    return await AxiosPermisos.get(uri.getAvailabilityUri + "/" + societyID, true);
    //+"/"+societyID
  },

  getSocietiesInfo: async (sharp_id) => {
    return await AxiosPermisos.get(uri.getSocietiesInfoURI + '/' + sharp_id, true);
  },

  getAbsenteeism: async (data) => {
    let id = data[0];
    let cc = data[1];
    return await AxiosPermisos.get(uri.getAbsenteeismUri + '/' + id + '/' + cc, {});
  },

  getSettings: async () => {
    return await AxiosPermisos.get(uri.getSettingsUri, true);
  },

  sendEmailDocs: async (id, files) => {
    return await AxiosPermisos.post(uri.sendEmailDocsUri + '/' + id, true, files);
  },

  getSites: async () => {
    return await AxiosPermisos.get(uri.getSitesUri, true);
  },

  getAllSitesBP: async (id_bp) => {
    return await AxiosPermisos.get(uri.getAllSitesBPUri + '/' + id_bp, true);
  },

  getSocieties: async () => {
    return await AxiosPermisos.get(uri.getSocietiesUri, true);
  },

  getModals: async () => {
    return await AxiosPermisos.get(uri.getModalsUri, {});
  },

  getDashboardBar: async (data) => {
    let params = "";
    let anno = data[0];
    if (data.length > 0) {
      params += '?';
      if (data[1]) {
        params += 'society_id=' + data[0] + '&';
      }
      if (data[2]) {
        params += 'site_id=' + data[1] + '&';
      }
    }
    return await AxiosPermisos.get(uri.getDashboardBarUri + '/' + anno + params, true);
  },

  getNotifications: async () => {
    return await AxiosPermisos.get(uri.getNotificationsUri, true);
  },

  updateStateNtftn: async (data) => {
    return await AxiosPermisos.patch(uri.getNotificationsUri, true, data);
  },

  updateReadNtftn: async (data) => {
    let id = data[0];
    let cc = data[1];
    return await AxiosPermisos.get(uri.updateReadNtftnUri + '/' + id + '/' + cc, {});
  },

  /*requestReview: async (id) => {   
    return await AxiosPermisos.get(uri.requestReviewUri+'/'+id, true);
  },*/

  saveObsAbse: async (data) => {
    return await AxiosPermisos.post(uri.saveObsAbseUri, {}, data);
  },

  getCities: async () => {
    return await AxiosPermisos.get(uri.getCitiesUri, true);
  },

  getStates: async () => {
    return await AxiosPermisos.get(uri.getStatesUri, true);
  },

  getCountries: async () => {
    return await AxiosPermisos.get(uri.getCountriesUri, true);
  },

  checkHoliday: async (date) => {
    return await AxiosPermisos.get(uri.checkHolidayUri + "/" + date, true);
  },

  /* 
   * 
   * ALL DEMANDS
   *
   */
  //Trae la informacion de las solicitudes de permisos
  GetLicenses: async () => {
    return await AxiosPermisos.get(uri.getLicensesUri, true);
  },

  GetLicensesAdv: async (data, query = {}) => {
    let params = ''
    params += `${map_query(query)}&`
    if (data.type === true) { params += 'type=oneday&' }
    if (data.range_init) { params += 'range_init=' + data.range_init + '&' }
    if (data.filter) { params += 'filter=' + data.filter + '&' }
    if (data.range_end) { params += 'range_end=' + data.range_end + '&' }
    if (data.page) { params += 'page=' + data.page + '&' }
    if (data.status[0]) { params += 'status[]=' + data.status[0] + "&" }
    if (data.status[1]) { params += 'status[]=' + data.status[1] + "&" }
    if (data.status[2]) { params += 'status[]=' + data.status[2] + "&" }
    return await AxiosPermisos.get(uri.getLicensesUri + params.slice(0,-1), true);
  },

  /* 
   *
   * APPROVALS 
   *
   */
  saveTktApproval: async (id, data) => {
    return await AxiosPermisos.post(uri.saveTktApprovalUri + "/" + id, true, data);
  },

  saveTktFile: async (id, file) => {
    return await AxiosPermisos.post(uri.saveTktFileUri + "/" + id, true, file);
  },

  saveApproval: async (id, data) => {
    return await AxiosPermisos.post(uri.saveApprovalUri + "/" + id, true, data);
  },

  /* 
   *
   * Help
   *
   */
  getFaq: async () => {
    return await AxiosPermisos.get(uri.getFaqUri, true);
  },


  /* 
   *
   * DERECHOS DE PETICION
   *
   */

  /* 
   *
   * RADICADOR
   *
   */
  getCategories: async () => {
    return await AxiosPermisos.get(uri.getCategoriesUri, true);
  },

  saveRightPetition: async (data) => {
    return await AxiosPermisos.post(uri.saveRightPetitionUri, true, data);
  },

  async enableToTurnReport (id,data)
  {
    return await AxiosPermisos.patch(uri.enableToTurnReport.concat(id), true, data, 'v2');
  },

  async getTurnReportLock ()
  {
    return await AxiosPermisos.get(uri.turnReportLock, true, 'v2');
  },

  async getIamIsLocked ()
  {
    return await AxiosPermisos.get(uri.iAmIsLocked, true, 'v2');
  },

  getRightPetition: async (data) => {
    let params = '?'
    if (data.id) {
      params += 'filter_user=true&';
    }
    if (data.bp && data.bp !== 0) {
      params += 'bpId=' + data.bp + '&';
    }
    if (data.status) {
      params += 'status=[' + data.status + ']&';
    }
    if (data.filter) {
      params += 'filter=' + data.filter + '&';
    }
    if (data.page) {
      params += 'page=' + data.page + '&';
    }
    return await AxiosPermisos.get(uri.saveRightPetitionUri + params, true);
  },

  /* 
   *
   * RESPONSABLE
   *
   */

  getInfoRP: async (id) => {
    return await AxiosPermisos.get(uri.saveRightPetitionUri + '/' + id, true);
  },

  getResponsibles: async () => {
    return await AxiosPermisos.get(uri.getResponsiblesUri, true);
  },

  saveInfoRP: async (id, data) => {
    return await AxiosPermisos.put(uri.saveInfoRPUri + "/" + id, true, data);
  },

  addUserForum: async (id, data) => {
    return await AxiosPermisos.post(uri.addUserForumUri + "/" + id, true, data);
  },

  getfiles: async (id) => {
    return await AxiosPermisos.get(uri.getfilesUri + "/" + id, true);
  },

  getDraft: async (id) => {
    return await AxiosPermisos.get(uri.getAnswersUri + "/temporal/" + id, true);
  },

  sendResponse: async (id, data) => {
    return await AxiosPermisos.post(uri.sendResponseUri + "/" + id, {}, data);
  },

  getInfoForum: async (id) => {
    return await AxiosPermisos.get(uri.getInfoForumUri + "/" + id, {});
  },

  sendComment: async (id, data) => {
    return await AxiosPermisos.post(uri.sendCommentUri + "/" + id, {}, data);
  },

  actPhisicalResponse: async (id, data) => {
    return await AxiosPermisos.put(uri.sendResponseUri + "/" + id, {}, data);
  },

  sendFilesForum: async (id, data) => {
    return await AxiosPermisos.post(uri.sendFilesForumUri + "/" + id, {}, data);
  },

  getEvidencesRP: async (id) => {
    return await AxiosPermisos.get(uri.getEvidencesRPUri + "/" + id, true);
  },

  deleteFileTemporalEvidence: async (id) => {
    return await AxiosPermisos.delete(uri.deleteTemporalEvidenceUri + "/" + id, true);
  },

  saveEvidenceRP: async (id, data) => {
    return await AxiosPermisos.post(uri.getEvidencesRPUri + "/" + id, true, data);
  },

  getTemporalEvidencesRP: async (id) => {
    return await AxiosPermisos.get(uri.getEvidencesRPUri + "/" + id, true);
  },

  saveTemporalEvidenceRP: async (id, data) => {
    return await AxiosPermisos.post(uri.getEvidencesRPUri + "/" + id, true, data);
  },

  sendRequestBP: async (id, data) => {
    return await AxiosPermisos.post(uri.sendRequestBPUri + "/" + id, true, data);
  },

  getInformerInfo: async (email) => {
    return await AxiosPermisos.get(uri.getInformerInfoUri + "/" + email, {});
  },

  deleteFileForum: async (id, params) => {
    return await AxiosPermisos.post(uri.deleteFileForumUri + "/" + id, {}, params);
  },

  deleteFileEvidence: async (id) => {
    return await AxiosPermisos.post(uri.deleteFileEvidenceUri + "/" + id, true);
  },

  putStatusForum: async (id, params) => {
    return await AxiosPermisos.post(uri.putStatusForumUri + "/" + id, true, params);
  },

  getDashboardRP: async (year) => {
    return await AxiosPermisos.get(uri.getDashboardRPUri + "/" + year, true);
  },

  sendPush: async (id) => {
    return await AxiosPermisos.post(uri.sendPushUri + "/" + id, true);
  },

  deleteFileRes: async (id, params) => {
    return await AxiosPermisos.post(uri.deleteFileResUri + "/" + id, true, params);
  },

  uploadFileRes: async (id, params) => {
    return await AxiosPermisos.post(uri.getfilesUri + "/" + id, true, params);
  },

  recategorize: async (id, params) => {
    return await AxiosPermisos.post(uri.recategorizeUri + "/" + id, true, params);
  },

  getAnswers: async (id) => {
    return await AxiosPermisos.get(uri.getAnswersUri + "/" + id, true);
  },

  setStatusUserFrm: async (id, params) => {
    return await AxiosPermisos.patch(uri.setStatusUserFrmUri + "/" + id, true, params);
  },

  validateUserFrm: async (idDP, idForum, params) => {
    return await AxiosPermisos.post(uri.validateUserFrmUri + "/" + idDP + "/" + idForum, true, params);
  },

  /*downloadFile: async (link) => {
    return await AxiosPermisos.get2(link, false, {responseType:"blob"});
  },*/

  /*
  *
  * DISCIPLINARY PROCESSES
  *
  */
  getEmployeesByCoordinator: async (data) => {
    let params = '?param=boss_id&key=' + data;
    return await AxiosPermisos.get(
      uri.coreEmployeesFilterUri + params,
      true,
      {}
    );
  },
  getReport: async (id) => {
    return await AxiosPermisos.get(uri.proceReportUri + '/' + id, true, {});
  },
  saveReport: async (data) => {
    return await AxiosPermisos.post(uri.proceReportUri, true, data);
  },
  saveReportEvidence: async (data) => {
    return await AxiosPermisos.post(uri.proceEvidencesUri, true, data);
  },
  saveReportEmployees: async (data) => {
    return await AxiosPermisos.post(uri.proceEmployeesUri, true, data);
  },
  updateProcessEmployee: async (data) => {
    return await AxiosPermisos.post(uri.proceEmployeesUri + '/' + data.id, true, data);
  },
  getCoordinatorsByBP: async (id) => {
    return await AxiosPermisos.get(uri.coordinatorsByBPUri + '/' + id, true, {});
  },
  getProceEmployee: async (id) => {
    return await AxiosPermisos.get(uri.proceEmployeesUri + "/" + id, true, {});
  },
  uptProceEmployee: async (data) => {
    return await AxiosPermisos.post(uri.proceEmployeesUri + '/' + data.id, true, data.formData);
  },
  addReportEmployeeCitation: async (data) => {
    return await AxiosPermisos.post(uri.proceCitationsUri, true, data);
  },
  updReportEmployeeCitation: async (data) => {
    return await AxiosPermisos.post(uri.proceCitationsUri + '/' + data.id, true, data.formData);
  },
  cancelReportEmployeeCitation: async (id) => {
    return await AxiosPermisos.delete(uri.proceCitationsUri + '/' + id, true);
  },
  addReportLaborRelations: async (data) => {
    return await AxiosPermisos.post(uri.proceLaborRelationsUri, true, data);
  },
  addReportLaborRelationsComment: async (data) => {
    return await AxiosPermisos.post(uri.proceCommentsUri, true, data);
  },
  addReportDiligence: async (data) => {
    return await AxiosPermisos.post(uri.proceDiligencesUri, true, data);
  },
  updtReportDiligence: async (data) => {
    return await AxiosPermisos.post(uri.proceDiligencesUri + '/' + data.id, true, data.formData);
  },
  getProcePenalties: async () => {
    return await AxiosPermisos.get(uri.procePenaltiesUri, true, {});
  },
  addProcePenaltyEvidence: async (data) => {
    return await AxiosPermisos.post(uri.procePenaltyEvidenceUri, true, data);
  },
  updProcePenaltyEvidence: async (data) => {
    return await AxiosPermisos.post(uri.procePenaltyEvidenceUri + '/' + data.id, true, data.formData);
  },
  getQuestionCategories: async () => {
    return await AxiosPermisos.get(uri.proceQuestionCategoriesUri, true, {});
  },
  getQuestions: async () => {
    return await AxiosPermisos.get(uri.proceQuestionsUri, true, {});
  },
  generatePDF: async (data) => {
    return await AxiosPermisos.post(uri.proceReportUri + '/pdf/generate', true, data);
  },
  saveRequestEvidence: async (data) => {
    return await AxiosPermisos.post(uri.proceRequestEvidenceUri, true, data);
  },
  getProceDashboard: async (data) => {
    return await AxiosPermisos.get(uri.proceDashboardControllerUri + '/' + data.model, true, {});
  },
  postProceDashboard: async (data) => {
    return await AxiosPermisos.post(uri.proceDashboardControllerUri + '/' + data.model, true, data.data);
  },
  getProcesses: async () => {
    return await AxiosPermisos.get(uri.proceEmployeesUri, true, {});
  },
  getCalendarDays: async (data) => {
    return await AxiosPermisos.post(uri.proceHolidaysUri, true, data);
  },

  /*** Virtual Partner V 2.0 ***/

  /**
   * 
   * Obtener opciones para varios select dependendiendo si ID
  */
  getSelectById: async (data) => {
    let params = '?'
    if (data.page) {
      params += 'page=' + data.page + '&';
    }
    if (data.filter) {
      params += 'search=' + data.filter + '&';
    }
    return await AxiosPermisos.get(uri.getSelectionsData + '/' + data.type_list_id + params, true, 'v2');
  },

  /**
   * 
   * Obtene Banco
  */
  getBank: async (id) => {
    return await AxiosPermisos.get(uri.getBanks + '/' + id, true, 'v2');
  },

  /**
   * 
   * Crear un Banco
  */

  saveBank: async (data) => {
    return await AxiosPermisos.post(uri.saveBank, true, data, 'v2');
  },

  /**
   * 
   * Editar un Banco
  */
  uptBank: async (data) => {
    let data1 = {
      "name": data.name,
      "type_list_id": data.type_list_id,
      "code": data.code,
    }
    return await AxiosPermisos.put(uri.getBanks + '/' + data.id, true, data1, 'v2');
  },

  /**
   * 
   * Eliminar un Banco
  */
  delBank: async (id) => {
    return await AxiosPermisos.delete(uri.getBanks + '/' + id, true, 'v2');
  },

  /**
   * 
   * Reportes de turnos V 2.0 ---------------------------------------------------------------------
  */
  getTipshift: async (id) => {
    return await AxiosPermisos.get(uri.getTipshiftReport + '/' + id, true, 'v2');
  },

  /**
   * 
   * Reportes de turnos V 2.0 por bodega
  */
  getTipshiftBodega: async (data) => {
    return await AxiosPermisos.post(uri.getTipshiftReportBodega, true, data, 'v2');
  },

  /**
   * 
   * Reportes de turnos V 2.0
  */
  getTipshiftEditar: async (data) => {
    return await AxiosPermisos.post(uri.getReportColaboradoresNovedades, true, data, 'v2');
  },

  /**
   * 
   * Obtener autocomplete novedades V 2.0
  */
  getAutocompleteNovedades: async (data) => {
    data = {
      "data": data
    };
    return await AxiosPermisos.post(uri.getAutocompleteNovedadesUrl + '0', true, data);
  },

  /**
   * Guardar turnos y novedades
  */
  saveNovedades: async (data) => {
    return await AxiosPermisos.post(uri.SetNovedadesUrl, true, data, 'v2');
  },

  /**
    * Guardar turnos y novedades
   */
  updateNovedades: async (data) => {
    return await AxiosPermisos.post(uri.SetUpdateNovedadesUrl, true, data, 'v2');
  },

  /**
    * 
    * Obtener autocomplete novedades V 2.0
   */
  getReportPropinas: async (data) => {
    return await AxiosPermisos.post(uri.getReportPropinas, true, data, 'v2');
  },

  /**
    * 
    * Obtener autocomplete novedades V 2.0
   */
  getReportColaboradoresNovedades: async (data) => {
    return await AxiosPermisos.post(uri.getReportColaboradoresNovedades, true, data, 'v2');
  },

  getReportHistory: async (data) => {
    return await AxiosPermisos.get(uri.getReportHistory + '/' + data, true, 'v2');
  },
  /**
   * 
   * Obtner bodegas por supervisor
  */
  getBodegasSupervisor: async () => {
    return await AxiosPermisos.get(uri.getBodegasSupervisorUrl, true, 'v2');
  },


  /**
   * PERFIL NOMINA****************************************************
   * 
   * Obtener lista de linea de Negocio
  */
  getLineDeals: async (page) => {
    let params = params = 'list?'
    if (page.page) {
      params += 'page=' + page.page + '&';
    } else if (page.filter) {
      params = page.filter
    }
    return await AxiosPermisos.get(uri.getLineDeal + '/' + params, true, 'v2');
  },

  /**
   * 
   * Crear una nueva linea de Negocio
  */

  getLineDeal: async (id) => {
    return await AxiosPermisos.get(uri.getLineDeal + '/' + id, true, 'v2');
  },

  /**
   * 
   * Crear una nueva linea de Negocio
  */

  saveLineDeal: async (data) => {
    return await AxiosPermisos.post(uri.saveLineDeal, true, data, 'v2');
  },

  /**
   * 
   * Editar linea de Negocio assignResponsiblePhotos
  */
  uptLineDeal: async (data) => {
    let data1 = {
      "name": data.name,
      "only_point_sale": data.only_point_sale,
      "by_score": data.by_score
    }
    return await AxiosPermisos.put(uri.actLineDeal + '/' + data.id, true, data1, 'v2');
  },

  /**
   * 
   * Eliminar linea de Negocio
  */
  delLineDeal: async (id) => {
    return await AxiosPermisos.delete(uri.delLineDeal + '/' + id, true, 'v2');
  },

  /**
    * 
    * Obtener autocomplete novedades V 2.0
   */
  getReportPdvEscenarios: async (data) => {
    return await AxiosPermisos.post(uri.getReportPdvEscenarios, true, data, 'v2');
  },

  /**
   * 
   * Obtener index de los escenarios
  */
  actGetIndex: async () => {
    return await AxiosPermisos.get(uri.getReportIndexList, true, 'v2');
  },
  /**
   * 
   * Guardar PDV con el escenario
  */
  saveReportPdvEscenarios: async (data) => {
    return await AxiosPermisos.put(uri.saveReportPdvEscenarios + "/" + data.id, true, data, 'v2');
  },

  /**
   * PERFIL NOMINA****************************************************
   * 
   * Obtener lista de Bolsas de Apoyo
   */
  getSupportBags: async (page) => {
    let params = '?'
    if (page.page) {
      params += 'page=' + page.page + '&';
    }
    return await AxiosPermisos.get(uri.getSupportBags + params, true, 'v2');
  },

  /**
 * 
 * Obtener lista de Bolsas de Apoyo por ID
 */
  getSupportBag: async (id) => {
    return await AxiosPermisos.get(uri.getSupportBags + '/' + id, true, 'v2');
  },

  // / */ * 
  //  * Crear una nueva Bolsas de Apoyo
  // */

  saveSupportBag: async (data) => {
    return await AxiosPermisos.post(uri.saveSupportBag, true, data, 'v2');
  },

  /**
   * 
   * Editar bolsa de apoyo
  */
  uptSupportBag: async (data) => {
    let data1 = {
      "name": data.name,
      "pro_line_deals": data.pro_line_deals,
      "only_percent": data.only_percent
    }
    return await AxiosPermisos.put(uri.getSupportBags + '/' + data.id, true, data1, 'v2');
  },
  /**
   * 
   * Eliminar bolsa de apoyo
  */
  delSupportBag: async (id) => {
    return await AxiosPermisos.delete(uri.getSupportBags + '/' + id, true, 'v2');
  },

  /**
   * PERFIL NOMINA****************************************************
   * 
   * Obtener lista de escenario
  */
  getScenario: async (page) => {
    let params = '?'
    if (page.page) {
      params += 'page=' + page.page + '&filter=' + page.filter + '&';
    }
    return await AxiosPermisos.get(uri.getScenario + params, true, 'v2');
  },

  /**
     * 
     * Obtener escenario por Linea de Negocio 
    */
  getScenarioByLd: async (id) => {
    return await AxiosPermisos.get(uri.getScenarioByLd + '/' + id, true, 'v2');
  },


  /**
   * 
   * Crear una nueva escenario
  */

  saveScenario: async (data) => {
    return await AxiosPermisos.post(uri.saveScenario, true, data, 'v2');
  },

  /**
   * 
   * Editar escenario
  */
  uptScenario: async (data) => {
    let data1 = {
      "name": data.name,
      "pro_line_deal_id": data.pro_line_deal_id
    }
    return await AxiosPermisos.put(uri.getScenario + '/' + data.id, true, data1, 'v2');
  },
  /**
   * 
   * Eliminar escenario
  */
  delScenario: async (id) => {
    return await AxiosPermisos.delete(uri.getScenario + '/' + id, true, 'v2');
  },

  /**
     * PERFIL NOMINA****************************************************
     * 
     * Obtener lista de Cargos
    */
  getCharges: async (page) => {
    let params = '?'
    if (page.filter) {
      params += 'search=' + page.filter + '&';
    }
    if (page.page) {
      params += 'page=' + page.page + '&';
    }
    return await AxiosPermisos.get(uri.getCharges + params, true, 'v2');
  },

  /**
     * 
     * Obtener cargo por ID 
    */
  getCharge: async (id) => {
    return await AxiosPermisos.get(uri.getCharge + '/' + id, true, 'v2');
  },

  /**
     * 
     * Obtener cargos por Punto de ventas
    */
  getChargesByPointSales: async (id) => {
    return await AxiosPermisos.get(uri.getChargesByPointSales + '/' + id, true, 'v2');
  },

  /**
  * 
  * Obtener Servicios
  */

  getServices: async () => {
    return await AxiosPermisos.get(uri.getServices, true, 'v2');
  },

  /**
  * 
  * Crear un nuevo Cargo
  */

  saveCharge: async (data) => {
    return await AxiosPermisos.post(uri.saveCharge, true, data, 'v2');
  },

  /**
  * 
  * Editar Cargo
  */
  uptCharge: async (data) => {
    let data1 = {
      "name": data.name,
      "category_type": data.category_type,
      "pro_category_id": data.pro_category_id,
      "pro_section_id": data.pro_section_id,
      "pro_scene_id": data.pro_scene_id,
      "core_role_id": data.core_role_id,
      "training": data.training
    }
    return await AxiosPermisos.put(uri.getCharge + '/' + data.id, true, data1, 'v2');
  },
  /**
  * 
  * Eliminar Cargo
  */
  delCharge: async (id) => {
    return await AxiosPermisos.delete(uri.getCharge + '/' + id, true, 'v2');
  },

  /**
     * PERFIL NOMINA****************************************************
     * 
     * Obtener Puntos de Venta
    */
  getPointsSales: async (page) => {
    let params = '?'
    if (page.filter) {
      params += 'search=' + page.filter + '&';
    }
    if (page.page) {
      params += 'page=' + page.page + '&';
    }
    return await AxiosPermisos.get(uri.getPointsSales + params, true, 'v2');
  },

  /**
     * 
     * Obtener Punto de Venta por Zona 
    */
  getPointsSalesByZone: async (id) => {
    return await AxiosPermisos.get(uri.getPointsSalesByZone + '/' + id, true, 'v2');
  },

  /**
     * 
     * Obtener Punto de Venta por ID e
    */
  getPointSales: async (id) => {
    return await AxiosPermisos.get(uri.getPointsSales + '/' + id, true, 'v2');
  },

  /**
     * 
     * Obtener Punto de Venta por ID e
    */
   getPointSalesByLineDeal: async (id) => {
    return await AxiosPermisos.get(uri.getPointSales + '/' + id, true, 'v2');
  },

  /**
  * 
  * Crear un Punto de Venta
  */

  savePointSale: async (data) => {
    return await AxiosPermisos.post(uri.savePointSale, true, data, 'v2');
  },

  /**
  * 
  * Editar un punto de Venta
  */
  uptPointSale: async (data) => {
    let data1 = {
      "name": data.name,
      "pro_line_deal_id": data.pro_line_deal_id,
      "code": data.code,
      "pro_zone_id": data.pro_zone_id,
      "status": 1,
    }
    return await AxiosPermisos.put(uri.actPointSale + '/' + data.id, true, data1, 'v2');
  },
  /**
  * 
  * Eliminar Punto de Venta
  */
  delPointSale: async (id) => {
    return await AxiosPermisos.delete(uri.delPointSale + '/' + id, true, 'v2');
  },

  /**
   * PERFIL NOMINA****************************************************
   * 
   * Obtener Grupo de Cargos
  */
  getGroupOfCharges: async (data) => {
    let params = '?'
    if (data.page) {
      params += 'page=' + data.page + '&';
    }
    if (data.filter) {
      params += 'search=' + data.filter + '&';
    }
    return await AxiosPermisos.get(uri.getGroupOfCharges + params, true, 'v2');
  },

  /**
   * 
   * Crear un Grupo de Cargos
  */

  saveGroupOfCharges: async (data) => {
    return await AxiosPermisos.post(uri.saveGroupOfCharges, true, data, 'v2');
  },

  /**
   * 
   * Editar Grupo de Cargos
  */
  uptGroupOfCharges: async (data) => {
    let data1 = {
      "name": data.name,
    }
    return await AxiosPermisos.put(uri.actGroupOfCharges + '/' + data.id, true, data1, 'v2');
  },

  /**
   * 
   * Eliminar Grupo de Cargos
  */
  delGroupOfCharges: async (id) => {
    return await AxiosPermisos.delete(uri.delGroupOfCharges + '/' + id, true, 'v2');
  },

  /**
   * PERFIL NOMINA****************************************************
   * 
   * Obtener Zonas
  */
  getZones: async (page) => {
    let params = '?'
    if (page.page) {
      params += 'page=' + page.page + '&';
    }
    return await AxiosPermisos.get(uri.getZones + params, true, 'v2');
  },

  /**
   * 
   * Obtener Zona por ID
  */
  getZone: async (id) => {
    return await AxiosPermisos.get(uri.getZone + '/' + id, true, 'v2');
  },

  /**
   * 
   * Obtener Zona por Linea de Negocio
  */
  getZoneByLB: async (id) => {
    return await AxiosPermisos.get(uri.getZoneByLB + '/' + id, true, 'v2');
  },

  /**
   * 
   * Crear un Zona
  */

  saveZone: async (data) => {
    return await AxiosPermisos.post(uri.saveZone, true, data, 'v2');
  },

  /**
   * 
   * Editar Zona
  */
  uptZone: async (data) => {
    let data1 = {
      "name": data.name,
      "pro_line_deal_id": data.pro_line_deal_id

    }
    return await AxiosPermisos.put(uri.getZone + '/' + data.id, true, data1, 'v2');
  },

  /**
   * 
   * Eliminar Zona
  */
  delZone: async (id) => {
    return await AxiosPermisos.delete(uri.getZone + '/' + id, true, 'v2');
  },

  /**
   * PERFIL NOMINA****************************************************
   * 
   * Obtener Empleados
  */
  getEmployees: async (page) => {
    let params = '?'
    if (page.filter) {
      params += 'search=' + page.filter + '&';
    }
    if (page.page) {
      params += 'page=' + page.page + '&';
    }
    return await AxiosPermisos.get(uri.getEmployees + params, true, 'v2');
  },

  /**
   * 
   * Obtener Empleado por ID
  */
  getEmployee: async (id) => {
    return await AxiosPermisos.get(uri.getEmployee + '/' + id, true, 'v2');
  },

  /**
   * 
   * Obtener Empleado por Linea de Negocio
  */
  getEmployeeByLB: async (id) => {
    return await AxiosPermisos.get(uri.getEmployeeByLB + '/' + id, true, 'v2');
  },

  /**
   * 
   * Obtener deplegables ejm(tipos de contrato, tipos de documentos...etc)
  */
  getLists: async () => {
    return await AxiosPermisos.get(uri.getLists, true, 'v2');
  },

  /**
   * 
   * // Evalua si la linea de negocio tiene o no zonas, para asi mismo devolver Puntos de ventas o Zonas
  */
  getCustomList: async (data) => {
    return await AxiosPermisos.get(uri.getCustomList + '/' + data.category_type + '/' + data.pro_category_id, true, 'v2');
  },

  /**
   * 
   * Crear un Empleado
   * 
  */

  saveEmployee: async (data) => {
    return await AxiosPermisos.post(uri.saveEmployee, true, data, 'v2');
  },

  /**
   * 
   * Editar Empleado
  */
  uptEmployee: async (data) => {
    let data1 = {
      "name": data.name,
      "document_type_id": data.document_type_id,
      "cc": data.cc,
      "email": data.email,
      "type_contract_id": data.type_contract_id,
      "sharp_id": data.sharp_id,
      "category_type": data.category_type,
      "pro_category_type_id": data.pro_category_type_id,
      "pro_zone_id": data.pro_zone_id,
      "pro_point_sale_id": data.pro_point_sale_id,
      "bank_id": data.bank_id,
      "account_type_id": data.account_type_id,
      "account_number": data.account_number,
      "position_id": data.position_id

    }
    return await AxiosPermisos.put(uri.getEmployee + '/' + data.id, true, data1, 'v2');
  },

  /**
   * 
   * Eliminar Empleado getInfoLineDeal
  */
  delEmployee: async (id) => {
    return await AxiosPermisos.delete(uri.getEmployee + '/' + id, true, 'v2');
  },

  /**
   * 
   * 
   * Obtener Roles de VP2
  */
  getRolesVP2: async () => {
    return await AxiosPermisos.get(uri.getRolesVP2, true, 'v2');
  },

  /**
     * PERFIL NOMINA**************   PUNTAJES
     * Consultar Información de Empleados, bolsas de apoyo y Escenarios  
    */
  getInfoLineDeal: async (id) => {
    return await AxiosPermisos.get(uri.getInfoLineDeal + '/' + id, true, 'v2');
  },

  /**
     * Consulta todas las bolsas de apoyo 
    */

  getAllSupportBags: async () => {
    return await AxiosPermisos.get(uri.getAllSupportBags, true, 'v2');
  },

  /**
     * Consulta si la bolsa de apoyo tiene puntaje diferenciado por Punto de venta, en la linea de Negocio 
    */
  getInfoBySupportBag: async (ids) => {
    return await AxiosPermisos.get(uri.getInfoBySupportBag + '/' + ids.lb + '/' + ids.sb, true, 'v2');
  },

  /**
     * Consulta los cargos asociados a la bolsa de apoyo
    */

  getChargesBySupportBag: async (id) => {
    return await AxiosPermisos.get(uri.getChargesBySupportBag + '/' + id, true, 'v2');
  },

  /**
     * Consulta los cargos asociados al escenario
    */
  getInfoByScenario: async (id) => {
    return await AxiosPermisos.get(uri.getInfoByScenario + '/' + id, true, 'v2');
  },

  /**
    * 
    * Guarda puntajes 
    * 
   */

  savePoints: async (data) => {
    switch (data.type) {
      case 1:
        // Guarda el puntaje de un CARGO atado directamente a la linea de negocio
        return await AxiosPermisos.post(uri.savePointsChargeByLineDeal, true, data, 'v2');
      case 2:
        // Guarda el puntaje de una BOLSA DE APOYO
        return await AxiosPermisos.post(uri.savePointsSupportBagByLineDeal, true, data, 'v2');
      case 3:
        // Guarda el puntaje de un CARGO atado a una escena
        return await AxiosPermisos.post(uri.savePointsChargeByScene, true, data, 'v2');
      case 4:
        // Guarda el puntaje de un PUNTO DE VENTA atado a una bolsa de apoyo
        return await AxiosPermisos.post(uri.savePointsSalesPointBySupportBag, true, data, 'v2');
      case 5:
        // Guarda el puntaje de un CARGO atado a una Bolsa de Apoyo
        return await AxiosPermisos.post(uri.savePointsChargesBySupportBag, true, data, 'v2');
      default:
    }
  },

  /**
   * Consulta el historial de Modificaciones
  */

  getModificationHistory: async (page) => {
    let params = '?'
    if (page.page) {
      params += 'page=' + page.page + '&';
    }
    return await AxiosPermisos.get(uri.getModificationHistory + params, true, 'v2');
  },
  /**
   * Consulta el historial de Ediciones
  */

  getUpdateHistory: async (page) => {
    let params = '?'
    if (page.page) {
      params += 'page=' + page.page + '&';
    }
    return await AxiosPermisos.get(uri.getUpdateHistory + params, true, 'v2');
  },

  /**
     * Obtener las propinas generales
    */
  getTipsGeneral: async () => {
    return await AxiosPermisos.post(uri.getTipsGeneral, true, {}, 'v2');
  },

  /**
   * Obtener las propinas por linea de negocio
  */
  getTipsLineDeal: async (data) => {
    return await AxiosPermisos.post(uri.getTipsLineDeal, true, data, 'v2');
  },

  /**
   * Obtener las propinas por zonas
  */
   getTipsZone: async (data) => {
    return await AxiosPermisos.post(uri.getTipsZone, true, data, 'v2');
  },

  /**
     * Obtener las propinas por punto de venta
    */
  getTipsPointSale: async (data) => {
    return await AxiosPermisos.post(uri.getTipsPointSale, true, data, 'v2');
  },

  /**
     * Obtener las propinas diarias
    */
  getTipsDaily: async (data) => {
    return await AxiosPermisos.post(uri.getTipsDaily, true, data, 'v2');
  },


  /**
     * Obtener las propinas POR PUNTOS DE VENTAS DATATABLE
    */
  getlistPointSales: async (data, pro_point_sale_id) => {
    let params = '?'
    if (data.page) {
      params += 'page=' + data.page + '&';
    }
    if (data.filter) {
      params += 'search=' + data.filter + '&';
    }
    return await AxiosPermisos.post(uri.listPointSales + '/' + pro_point_sale_id + params, true, data, 'v2');
  },

  /**
     * Obtener las propinas POR ZONAS
    */
   getlistZoneSales: async (data, pro_point_sale_id) => {
    let params = '?'
    if (data.page) {
      params += 'page=' + data.page + '&';
    }
    if (data.filter) {
      params += 'search=' + data.filter + '&';
    }
    return await AxiosPermisos.post(uri.listZoneSales + '/' + pro_point_sale_id + params, true, data, 'v2');
  },

  /**
     * Obtener el listado de todas la novedades DATATABLE
    */
  getlistNovelties: async (data) => {
    return await AxiosPermisos.post(uri.listNovelties, true, data, 'v2');
  },

  /**
     * Obtener el detalle de las novedades
    */
  getlistDetailNovelties: async (data) => {
    return await AxiosPermisos.post(uri.listDetailNovelties + '/' + data.id_novedad, true, data, 'v2');
  },

  /**
     * Confirmar novedad
    */
  confirmNoveltie: async (data) => {
    return await AxiosPermisos.post(uri.confirmNoveltie + '/' + data.id, true, data, 'v2');
  },



  /**
     * Obtener las propinas diarias POR PUNTOS DE VENTAS DATATABLE
    */
  getlistPointSalesDaily: async (data) => {
    let params = '?'
    if (data.page) {
      params += 'page=' + data.page + '&';
    }
    if (data.filter) {
      params += 'search=' + data.filter + '&';
    }

    return await AxiosPermisos.post(uri.listPointSalesDaily + params, true, data, 'v2');
  },


  /**
     * Obtener el listado de las zonas
    */
  getlistZones: async (pro_point_sale_id) => {
    return await AxiosPermisos.get(uri.listZones + '/' + pro_point_sale_id, true, 'v2');
  },

  /**
     * Obtener el listado de las lineas de negocio
    */
  getlistDeals: async () => {
    return await AxiosPermisos.get(uri.getlineDeals, true, 'v2');
  },



  /**
     * PERFIL JEFE DE ZONA **************   ENTRENAMINETO 
     * Consulta las solicitudes de entrenamiento, que se generan en el back cuando actualizan el cargo a cualquier empleado a un cargo en entrenamiento
    */
  getTrainingInfo: async (page) => {
    let params = '?'
    if (page.page) {
      params += 'page=' + page.page + '&';
    }
    if (page.filter) {
      params += 'search=' + page.filter + '&';
    }
    if (page.status !== []) {
      params += 'status=' + page.status + '&';
    }
    return await AxiosPermisos.get(uri.getTrainingInfo + params, true, 'v2');
  },

  /**
     * Consulta los entrenamientos por ID
    */
  getTrainingInfoById: async (id) => {
    return await AxiosPermisos.get(uri.getTrainingInfo + '/' + id, true, 'v2');
  },

  /**
     * Consulta los entrenamientos por ID
    */
  saveTrainingInfo: async (data) => {
    return await AxiosPermisos.put(uri.getTrainingInfo + '/' + data.id, true, data, 'v2');
  },

  /**
     * Genera la plantilla de para la creación de empleados
    */
  generateExcelWorkers: async () => {
    return await AxiosPermisos.get(uri.generateExcelWorkers, true, 'v2');
  },

  /**
   * Carga el archivo de empleados 
  */
  saveFileEmployee: async (data) => {
    return await AxiosPermisos.post(uri.saveFileEmployee, true, data, 'v2');
  },


  //++++++++++++++++++++++++++++++++++++++++++++++++++//
  //////+++++++++++ HEALTH TRACKER ++++++++++++++///// 
  //++++++++++++++++++++++++++++++++++++++++++++++++++// 


   //////+++++++++++ ausentismos ++++++++++++++///// 

  /**
  * Consulta los trabajadores
 */

  getEmployeesBySearch: async (data) => {
    let params = '?'
    if (data.search) {
      params += 'search=' + data.search + '&';
    }
    if (data.macro) {
      params += 'macro=' + data.macro;
    }
    return await AxiosPermisos.get(uri.getEmployeesBySearch + params, true, 'v2');
  },

  /**
   * Obtiene la información general de cualquier empleado
  */

  getEmployeeInfo: async (id) => {
    return await AxiosPermisos.get(uri.getEmployeeInfo + '/' + id, true, 'v2');
  },

  /**
   * Consulta los tipos de ausentismo
  */

  getTypesAbsenteeism: async (search) => {
    let params = '?'
    if (search) {
      params += 'q=' + search + '&';
    }
    return await AxiosPermisos.get(uri.getTypesAbsenteeism + params, true, 'v2');
  },

  /**
     * Consulta los grupos de Diagnosticos 
    */

  getGroupsDiagnostics: async (search) => {
    let params = '?'
    if (search) {
      params += 'q=' + search + '&';
    }
    return await AxiosPermisos.get(uri.getGroupsDiagnostics + params, true, 'v2');
  },

  /**
     * Consulta los grupos de Diagnosticos 
    */

  getDiagnostics: async (search) => {
    let params = '?'
    if (search.search) {
      params += 'q=' + search.search + '&';
    }
    return await AxiosPermisos.get(uri.getDiagnostics + '/' + search.group + params, true, 'v2');
  },

  /**
     * Consulta la Clasificación del origen del peligro o riesgo
    */

  getRiskClassification: async (search) => {
    let params = '?'
    if (search) {
      params += 'q=' + search + '&';
    }
    return await AxiosPermisos.get(uri.getRiskClassification + params, true, 'v2');
  },

  /**
     * Trae las listas desplegables del formulario de Creación de ausentismos 
    */

  getListsAbsenteeism: async () => {
    return await AxiosPermisos.get(uri.getListsAbsenteeism, true, 'v2');
  },

  /**
     * Guarda el Ausentismo
    */
  saveAbsenteeism: async (data) => {
    return await AxiosPermisos.post(uri.saveAbsenteeism, true, data, 'v2');
  },

  /**
     * Consulta propinas de trabajadores
    */

  TipsEmployee: async (data) => {
    let data1 = data;
    return await AxiosPermisos.post(uri.getTipsEmployee, true, data1, 'v2');
  },
  /**
   * Trae un ausentismo por ID
  */

  getAbsenteeismHT: async (id) => {
    return await AxiosPermisos.get(uri.getAbsenteeism + '/' + id, true, 'v2');
  },

  /**
   * Actualiza el Ausentismo
  */
  actAbsenteeism: async (data) => {
    return await AxiosPermisos.put(uri.getAbsenteeism + '/' + data.id, true, data, 'v2');
  },

  /**
   * Trae el historial de cambios en los ausentismos
  */

  getHistoryOfAbsenteeism: async (data) => {
    let params = '?'
    if (data.page) {
      params += 'page=' + data.page + '&';
    }
    return await AxiosPermisos.get(uri.getHistoryOfAbsenteeism + '/' + data.id + params, true, 'v2');
  },

  /**
 * Trae el detalle de los ausentismos
*/
  getDetailAbsenteeism: async (data) => {
    let params = '?'
    if (data.page) {
      params += 'page=' + data.page + '&';
    }
    if (data.start_date) {
      params += 'start_date=' + data.start_date + '&';
    }
    if (data.end_date) {
      params += 'end_date=' + data.end_date + '&';
    }
    if (data.types_absenteeism) {
      params += 'types_absenteeism=' + '[' + data.types_absenteeism + ']' + '&';
    }
    if (data.diagnosis_cie_id) {
      params += 'diagnosis_cie_id=' + data.diagnosis_cie_id + '&';
    }
    return await AxiosPermisos.get(uri.getDetailAbsenteeism + '/' + data.id + params, true, 'v2');
  },

  /**
   * Carga de archivo de empleados Heath Tracker
   */

  saveFileEmployeeHT: async (data) => {
    return await AxiosPermisos.postSendFile(uri.saveFileEmployeeHT, true, data, 'v2');
  },

  /**
   * Carga de archivo CIE-10
   */

  save_file_cie_10_ht: async (data) => {
    return await AxiosPermisos.post(uri.save_file_cie10_ht, true, data, 'v2');
  },


  /**
   * Carga de archivo del historial de Ausentismos
   */

  saveFileAbs: async (data) => {
    return await AxiosPermisos.postSendFile(uri.saveFileAbs, true, data, 'v2');
  },


  /**
   * Guardar archivo plano siesa
   */

  saveFileSiesa: async (data) => {
    return await AxiosPermisos.post(uri.saveFileSiesa, true, data, 'v2');
  },

  /**
   * Trae los desplegables del filtro por ID 
  */

  filterEmployeeDetail: async (id) => {
    return await AxiosPermisos.get(uri.filterEmployeeDetail + '/' + id, true, 'v2');
  },

  /**
 * Filtra las estadisticas por: Area/Sociedad
*/

  filterStadistics: async (data) => {
    let link = '?'
    if (data.macro) {
      link += 'ht_macro_ent_name_id=' + data.macro + '&'
    }
    if (data.area) {
      link += 'core_area_id=' + data.area + '&'
    }
    if (data.start_date) {
      link += 'start_date=' + data.start_date + '&'
    }
    if (data.end_date) {
      link += 'end_date=' + data.end_date
    }
    return await AxiosPermisos.get(uri.filterStadistics + link, true, 'v2');
  },

  /**
* Trae todas las sociedades
*/

  getAllSocietys: async () => {
    return await AxiosPermisos.get(uri.getAllSocietys, true, 'v2');
  },

  /**
   * Trae todas las areas
  */

  getAllAreas: async (id) => {
    let filter = '?ht_macro_ent_name_id='
    return await AxiosPermisos.get(uri.getAllAreas + filter + id, true, 'v2');
  },

  /**
   * Trae el telefono del Empleado 
  */

   getEmployeePhone: async (id) => {
    return await AxiosPermisos.get(uri.getEmployeePhone + '/' + id, true, 'v2');
  },

  /**
  * 
  * Guarda el telefono del empleado
  */
  saveEmployeePhone: async (data) => {
    let phone = {
      phone:data.phone
    }
    return await AxiosPermisos.put(uri.saveEmployeePhone + '/' + data.id, true, phone, 'v2');
  },

  /**
* Trae las tablas del reporte 
*/
  getTablesReport: async (data) => {
    let link = '?'
    if (data.type) {
      link += 'type=' + data.type + '&'
    }
    if (data.macro) {
      link += 'ht_macro_ent_name_id=' + data.macro + '&'
    }
    if (data.area) {
      link += 'core_area_id=' + data.area + '&'
    }
    if (data.start_date) {
      link += 'start_date=' + data.start_date + '&'
    }
    if (data.end_date) {
      link += 'end_date=' + data.end_date + '&'
    }
    if (data.page) {
      link += 'page=' + data.page
    }
    return await AxiosPermisos.get(uri.getTablesInform + link, true, 'v2');
  },

  /**
* Trae la tabla de empleados para chekear si tienen o no Foto
*/
  checkEmployeesWithPhoto: async (data) => {
    let link = '?'
  if(data.status){
    link += 'status=' + data.status  + '&'
  }
  if(data.search){
     link += 'search=' + data.search + '&'
  }
  if (data.page) {
    link += 'page=' + data.page
  }
    return await AxiosPermisos.get(uri.checkEmployeesWithPhoto + link, true, 'v2');
  },

   /**
* Trae la tabla de empleados para chekear si tienen o no Telefono
*/
checkEmployeesWithPhone: async (data) => {
  let link = '?'
  if(data.status){
    link += 'status=' + data.status  + '&'
  }
  if(data.search){
     link += 'search=' + data.search + '&'
  }
  if (data.page) {
    link += 'page=' + data.page
  }
  return await AxiosPermisos.get(uri.checkEmployeesWithPhone + link, true, 'v2');
},

  /**
  * Revisa si existe un responsable de las fotos
 */
  checkResponsiblePhotos: async () => {
    return await AxiosPermisos.get(uri.checkResponsiblePhotos, true, 'v2');
  },

  /**
    * Revisa si existe un responsable de las fotos
   */
  checkResponsiblePhones: async () => {
    return await AxiosPermisos.get(uri.checkResponsiblePhones, true, 'v2');
  },

  /**
* 
* Editar responsable de subir fotografias
*/
  assignResponsiblePhotos: async (id) => {
    let data = 'prueba'
    return await AxiosPermisos.put(uri.assignResponsiblePhotos + '/' + id, true, data, 'v2');
  },

  /**
* 
* Editar responsable de subir los telefonos
*/
assignResponsiblePhones: async (id) => {
  let data = 'prueba'
  return await AxiosPermisos.put(uri.assignResponsiblePhones + '/' + id, true, data, 'v2');
},

 /**
* 
* Sube fotografias
*/
uploadImagesEmployees: async (data) => {
  return await AxiosPermisos.post(uri.uploadImagesEmployees , true, data, 'v2');
},

 /**
* 
* Sube el archivo .csv de teléfonos
*/
uploadPhonesEmployees: async (data) => {
  return await AxiosPermisos.post(uri.uploadPhonesEmployees , true, data, 'v2');
},

 /**
  * Revisa el progreso de la carga de telefonos de los empleados
 */
  getProgressBarPhones: async () => {
    return await AxiosPermisos.get(uri.progressBarPhones, true, 'v2');
  },

   /**
  * Revisa el progreso de la carga de imagenes de los empleados
 */
    getProgressBarPhotos: async () => {
      return await AxiosPermisos.get(uri.progressBarPhotos, true, 'v2');
    },

   //////+++++++++++ GES ++++++++++++++/////
 
   /**
    * 
    * Traer la lista de SVE
    */

    getSVElist: async () => {
      return await AxiosPermisos.get(uri.getSVElist, true, 'v2');
    },

    /**
    * 
    * Guarda un nuevo GES
    */
    saveGES: async (data) => {
      return await AxiosPermisos.post(uri.saveGES , true, data, 'v2');
    },

    /**
    * 
    * Edita un GES
    */
     editGES: async (data) => {
      let link = '?';
      link += 'name=' + data.name;
      link +=  '&code_type_ges=' + data.code_type_ges; 
      link +=  '&sve_id=' + data.sve_id; 
      link +=   '&' + data.employees;    
      return await AxiosPermisos.put(uri.getGES + '/' + data.id + link, true, '', 'v2');
    },

    /**
    * 
    * Elimina un GES
    */
     deleteGES: async (id) => {
      return await AxiosPermisos.delete(uri.getGES + '/' + id, true, 'v2');
    },

    /**
    * 
    * Traer GESs paginados 
    */

     getGESTable: async (data) => {
      return await AxiosPermisos.get(uri.getGESTable,true, 'v2', data);
    },

    /**
    * 
    * Traer empleados ligados a un GES
    */

     getGESTableEmployees: async (data) => {
      let link = `?gesId=${data.id}`
      if(data.page){
        link += `&page=${data.page}`    
      }
      return await AxiosPermisos.get(uri.getEmployeeGES + link, true, 'v2');
    },

    /**
    * 
    * Guarda empleados en un GES  
    */

     saveEmployeeGES: async (data) => {
      const data2="";
       return await AxiosPermisos.post(uri.saveEmployeeGES +'/' + data.ht_ges_id +'/employees?' + data.employees, true,data2, 'v2');
      },

    /**
    * 
    * Elimina empleados ligados a un GES 
    */

     deleteEmployeeGES: async (data) => {
      return await AxiosPermisos.delete(uri.deleteEmployeeGES +'/' + data.ges_id +'/employees?' + data.employee, true, 'v2');
    },

    /**
    * 
    * Trae la información completa de un GES
    */

     getGES: async (id) => {
      return await AxiosPermisos.get(uri.getGES +'/' + id, true, 'v2');
    },

    /**
    * 
    * Trae el Historial de modificaciónes de un GES 
    */

     getHistoryGES: async ({ id, page }) => {
      return await AxiosPermisos.get(uri.getHistoryGES +'/' + id + '?page=' + page, true, 'v2');
    },


     /**
    * 
    * Trae sve para el dashboard
    */
     getSveDash: async (data) => {
      return await AxiosPermisos.get(uri.getSveDash, true, 'v2', data);
    },
    getSveDash_Char: async (data) => {
      return await AxiosPermisos.get(uri.getSveDash_Char, true, 'v2', data);
    },
    getSveGesClDash: async (data) => {
      return await AxiosPermisos.get(uri.getSveGesClDash, true, 'v2', data);
    },
    getSveDashPandA: async (data) => {
      return await AxiosPermisos.get(uri.getSveDashPandA, true, 'v2', data);
    },
     getSveGesDash: async ({data, id, page}) => {
      let link = "?";
      if(page){
        link +=`page=${page}&`    
     }
      if(data){
        link +=`${data}`    
     }
      return await AxiosPermisos.get(uri.getSveGesDash + '/' + id + link, true, 'v2');
    },
    getSvePercDash: async (data) => {
     
      return await AxiosPermisos.get(uri.getSvePercDash +'/' + data.ges_id +'?code_type_ges=' + data.code_type_ges, true, 'v2');
    },
    getSveGesOha: async () => {     
      return await AxiosPermisos.get(uri.getSveGesOha, true, 'v2');
    },

     //////+++++++++++ POTENCIAL RISK ++++++++++++++/////

     getGesPotencialRisk: async (id) => {
      return await AxiosPermisos.get(uri.getGesPotencialRisk +'/' + id, true, 'v2');
    },

    saveGesPotencialRisk: async (data) => {
      return await AxiosPermisos.put(uri.saveGesPotencialRisk + '/' + data.ges.id, true, data, 'v2');
    },

    //////+++++++++++ HISTORICO LABORAL ++++++++++++++/////   

    /**
    * 
    * Guarda el archivo de historico laboral 
    */

     uploadFileHistoryWorker: async (data) => {
      return await AxiosPermisos.post(uri.uploadFileHistoryWorker, true, data, 'v2');
    },

   //////+++++++++++ REGISTRO DE DIAGNOSTICOS ++++++++++++++///// 
     /**
    * 
    * trae las listas para el formulario 
    */
    getListsForDiagnostics: async () => {
      return await AxiosPermisos.get(uri.getListsForDiagnostics, true, 'v2');
    },
    /**
    * 
    * trae todos los diagnosticos registrados de una persona 
    */
   getAllDiagnostics: async (data) => {
     let link = ''
    if(data.page){
      link += '?page=' + data.page
    }
    return await AxiosPermisos.get(uri.getAllDiagnostics +'/' + data.id + link, true, 'v2');
  },

  /**
    * 
    * trae el diagnostico completo de una persona 
    */
   getCompleteDiagnostic: async (id) => {
    return await AxiosPermisos.get(uri.getCompleteDiagnostic +'/' + id, true, 'v2');
  },

  /**
    * 
    * Guarda un nuevo diagnostico 
    */

   saveNewDiagnostic: async (data) => {
    return await AxiosPermisos.post(uri.saveNewDiagnostic, true, data, 'v2');
  },

  /**
    * 
    * trae el diagnostico registrado de una persona 
    */
   getDiagnostic: async (id) => {
    return await AxiosPermisos.get(uri.getDiagnostic +'/' + id, true, 'v2');
  },

   /**
    * 
    * Edita un diagnostico 
    */

    editDiagnostic: async (data) => {
      return await AxiosPermisos.put(uri.editDiagnostic +'/' + data.id, true, data, 'v2');
    },

  /**
    * 
    * Elimina un diagnóstico
    */
   deleteDiagnostic: async (id) => {
    return await AxiosPermisos.delete(uri.deleteDiagnostic +'/' + id, true, 'v2');
  },

  //CALIFICACIÓN DE DIAGNOSTICOS
  /**
    * 
    * Guarda una nueva calificación 
    */

   saveNewCalification: async (data) => {
    return await AxiosPermisos.post(uri.saveNewCalification, true, data, 'v2');
  },

    /**
    * 
    * trae todos las califiaciones de un diagnostico
    */
     getListCalifications: async (id) => {
      return await AxiosPermisos.get(uri.getListCalifications + '/' + id, true, 'v2');
    },

    /**
    * 
    * trae la califiacion de un diagnostico
    */
     getCalification: async (id) => {
      return await AxiosPermisos.get(uri.getCalification + '/' + id, true, 'v2');
    },

    /**
    * 
    * Edita una nueva calificación 
    */

     editCalification: async (data) => {
      var data2
      data2 = data
      let id = data2.get('id')
    return await AxiosPermisos.post(uri.editCalification  + '/' + id, true, data, 'v2');
    },

    /**
    * 
    * Elimina la calificación 
    */

     deleteCalification: async (id) => {
      return await AxiosPermisos.delete(uri.editCalification  + '/' + id, true, 'v2');
    },

    //APT DE DIAGNOSTICOS 
  /**
    * 
    * Guarda un APT
    */

   saveNewAPT: async (data) => {
    return await AxiosPermisos.post(uri.saveNewAPT, true, data, 'v2');
  },

  /**
    * 
    * trae las enfermedades que se tienen el empleado con una calificación en firme
    */
   getListDiseases: async (id) => {
    return await AxiosPermisos.get(uri.getListDiseases + '/' + id, true, 'v2');
  },

    /**
    * 
    * trae todos los APTs de un diagnostico
    */
     getListAPTs: async (id) => {
      return await AxiosPermisos.get(uri.getListAPTs + '/' + id, true, 'v2');
    },

    /**
    * 
    * trae un APT
    */
     getAPT: async (id) => {
      return await AxiosPermisos.get(uri.getAPT + '/' + id, true, 'v2');
    },

    /**
    * 
    * Edita un APT
    */

    editAPT: async (data) => {
      var data2
      data2 = data
      let id = data2.get('id')
      return await AxiosPermisos.post(uri.editAPT  + '/' + id, true, data, 'v2');
    },

    /**
    * 
    * Elimina un APT
    */

     deleteAPT: async (id) => {
      return await AxiosPermisos.delete(uri.editAPT  + '/' + id, true, 'v2');
    },

    //PCL DE DIAGNOSTICOS
  /**
    * 
    * Guarda un PCL
    */

   saveNewPCL: async (data) => {
    return await AxiosPermisos.post(uri.saveNewPCL, true, data, 'v2');
  },

    /**
    * 
    * trae todos los PCLs de un diagnostico
    */
     getListPCLs: async (id) => {
      return await AxiosPermisos.get(uri.getListPCLs + '/' + id, true, 'v2');
    },

    /**
    * 
    * trae un PCL
    */
     getPCL: async (id) => {
      return await AxiosPermisos.get(uri.getPCL + '/' + id, true, 'v2');
    },

    /**
    * 
    * Edita un PCL
    */

    editPCL: async (data) => {
      var data2
      data2 = data
      let id = data2.get('id')
      return await AxiosPermisos.post(uri.editPCL  + '/' + id, true, data, 'v2');
    },

    /**
    * 
    * Elimina un PCL
    */

     deletePCL: async (id) => {
      return await AxiosPermisos.delete(uri.editPCL  + '/' + id, true, 'v2');
    },    

    /**
    * 
    * Guarda un nuevo SVE
    */
    saveSVE: async (data) => {
      return await AxiosPermisos.post(uri.saveSVE , true, data, 'v2');
    },

    /**
    * 
    * Traer SVEs paginados
    */

     getSVETable: async (data) => {
      let link = '?'
      if(data.type){
        link += 'type=' + data.type  + '&'
      }
      if(data.page){
        link += 'page=' + data.page
      }
      return await AxiosPermisos.get(uri.getSVETable + link, true, 'v2');
    },

    

}
